import {IAppState} from '@/interfaces/store-interfaces/app-state.interface';
import {ActionContext} from 'vuex';
import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';
import router from '@/router/router';
import ROUTE_NAME = RouterStore.ROUTE_NAME;

type StoreActionContext = ActionContext<RouterStore.IRouterStoreState, IAppState>;

export default {
  namespaced: true,

  state: {

  },

  mutations: {

  },

  actions: {
    async openPage({ rootState }: StoreActionContext, { url, routeName, query, external }: { url?: string; routeName?: ROUTE_NAME; query?: any; external?: boolean; }) {
      if (external) {
        window.open(url, '_blank')
      }
      else if (rootState.route.name !== routeName && rootState.route.path !== url) {
        let routerParams: any = {};

        if (url)  routerParams.path = url;
        if (routeName)  routerParams.name = routeName;
        if (query)  routerParams.query = query;

        await router.push(routerParams);
      }
    },

    async openThemePage({ rootState }: StoreActionContext, themeId: number) {
      await router.push({ name: ROUTE_NAME.PATH_PAGE, params: { id: themeId.toString() }});
    },

    async openFilmPage({ rootState }: StoreActionContext, filmId: number) {
      await router.push({ name: ROUTE_NAME.DETAIL_PAGE, params: { id: filmId.toString() }});
    }
  }
};
